import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import {
  applyStylesForScreenSize,
  SCREEN_SIZES,
} from 'brand-guidelines/utils/screenSizeUtils';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Text = styled.span`
  ${TYPOGRAPHY.CIRCULAR.bold};
  word-break: keep-all;
  color: ${BRAND_COLORS.red};
  text-align: center;
  font-size: 14px;
  line-height: 22px;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      font-size: 12px;
      line-height: normal;
    `,
  )}
`;
